import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Product = styled.div.withConfig({
  displayName: "Product",
  componentId: "sc-1frzbze-0"
})(["display:flex;", ";small{display:block;", ";}a{color:currentColor;&:hover{color:", ";}}h4{padding-bottom:3px;margin:0;", ";font-weight:700;}"], function (_ref) {
  var align = _ref.align;
  return align && "align-items: ".concat(align, ";");
}, getFont(-1, 'compact'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.linkColor;
}, getFont(0, 'compact'));